var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{domProps:{"innerHTML":_vm._s(_vm.permissions)}})
}
var staticRenderFns = []

export { render, staticRenderFns }